import moment from "moment";
import {
  REPORT_LOADING,
  SET_RESULT_TYPES,
  SET_RESULT_SUBTYPES,
  SET_RESULT_COUNTS,
  SET_RESULT_STATS,
  RESET_REPORTS,
  ADD_REPORT_ERROR,
} from "../constants";

// State
import mapColorsToLabels from "../../utils/mapColorsToLabel";
import { RESULT_SESSION_TOKEN } from "../actions/resultsActions";

let SAVED_STATE = JSON.parse(sessionStorage.getItem(RESULT_SESSION_TOKEN));
if (SAVED_STATE && moment().isAfter(SAVED_STATE.expires_at)) {
  SAVED_STATE = null;
}

const initial_state = {
  errors: {},
  loading: {},

  // User selected options
  options: {
    startDateTime: moment().subtract(1, "day").startOf("day"), // Default: start of yesterday
    endDateTime: moment().endOf("day"), // Default: through today
    types: "all", // BILL_TO_DATE, DISCONNECT, EBILL, ...
    subTypes: "all", // COMPLETE, NEW, PAYMENT_RECEIVED, ...
    companyCode: "all", // Illinois, Missouri, ...
    expires_at: moment().add(1, "hour").toJSON(),
    ...SAVED_STATE,
  },

  // Options for dropdowns
  types: [], // "BILL_TO_DATE", "DISCONNECT", "EBILL", ...
  subTypes: [], // "COMPLETE", "NEW", "PAYMENT_RECEIVED", ...
  companyCodes: [], // "Illinois", "Missouri", ...

  // Display Data based on selections above
  sent: [
    /* {type_vch: String, subtype_vch: String, count: Number}, ... */
  ],
  totals: {
    /*  received: Number, email: Number,  sms: Number, voice: number, total: number */
  },
  stats: {
    /* email: [{ dispatched: Number, delivered: Number, ...}, sms: [{...}] */
  },
};

export default function (state = initial_state, { type, payload, name }) {
  let { loading, errors } = state;

  switch (type) {
    case REPORT_LOADING:
      loading[payload] = true;

      return {
        ...state,
        loading: { ...loading },
      };

    case ADD_REPORT_ERROR:
      // If provided, clear loading
      name && (loading[name] = false);

      if (payload.message) {
        payload = {
          [name]:
            "Loading data is taking too long because of large number of results. Try to reduce the date range and try again",
        };
      }

      // Set errors
      errors = {
        ...errors,
        ...payload,
      };
      return {
        ...state,
        errors,
        loading: { ...loading },
      };

    case SET_RESULT_TYPES:
      loading["types"] = false;
      delete errors["types"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        types: payload || [],
      };

    case SET_RESULT_SUBTYPES:
      loading["subTypes"] = false;
      delete errors["subTypes"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        subTypes: payload || [],
      };

    case SET_RESULT_COUNTS:
      loading["counts"] = false;
      delete errors["counts"]; // clear previous errors

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        sent: payload.sent || [],
        totals: payload.totals || {},
      };

    case SET_RESULT_STATS:
      loading["stats"] = false;
      delete errors["stats"]; // clear previous errors

      Object.values(payload).forEach((statuses) => {
        mapColorsToLabels(statuses.map(({ status }) => status));
      });

      return {
        ...state,
        errors: { ...errors },
        loading: { ...loading },
        stats: payload || {},
      };

    case RESET_REPORTS:
      return { ...initial_state };

    default:
      return state;
  }
}
